// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"5364":"d709474b02cd980a","6681":"230e61f1dc330f7b"}[chunkId] + ".js";
};